export default {"src":"/_next/static/media/VRT.c3547b41.svg","height":18,"width":18};